<template>
  <div class="wrap">
    <van-sticky>
      <van-nav-bar title="积分提取" left-arrow @click-left="$router.go(-1)" right-text="提取记录"
        @click-right='$router.push({name:"mywalletlist"})' />
    </van-sticky>
    <div class="withdrawCon">
      <!-- 提现配置 -->
      <van-cell-group>
        <van-cell title="提现基数" :value="configTemp.cardinal_number" />
        <van-cell title="最低提现值" :value="configTemp.min" />
        <van-cell title="最高提现值" :value="configTemp.max" />
        <van-cell title="手续费" :value="configTemp.rate" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="temp.pay_password" label="支付密码" placeholder="请输入支付密码" required type='password'
          input-align="right" />
        <van-field v-model="temp.money" label="提现金额" placeholder="请输入提现金额" required input-align="right"
          @input="getReal" />
      </van-cell-group>
      <van-cell title="到账金额" :value="realMoney" />
      <!-- 选择提现方式 -->
      <van-cell title="提现方式" :value="typeName" is-link @click="typeShow = true" />
      <!-- <div v-if="type==1">
        <van-field v-model="temp.bank_name" label="开户银行" placeholder="请输入开户银行" input-align="right" />
        <van-field v-model="temp.bank_open" label="开户支行" placeholder="请输入开户支行" input-align="right" />
        <van-field
          v-model="temp.bank_open_name"
          label="开户人姓名"
          placeholder="请输入开户人姓名"
          input-align="right"
        />
        <van-field
          v-model="temp.bank_number"
          label="银行卡号"
          placeholder="请输入银行卡号"
          input-align="right"
        />
      </div>-->
      <!-- <div v-if="type==2">
        <van-field
          v-model="temp.ali_number"
          label="支付宝账号"
          placeholder="请输入支付宝账号"
          input-align="right"
        />
        <van-cell title="支付宝收款码">
          <div slot="default">
            <van-uploader :after-read="upAli">
              <img :src="temp.ali_image" alt v-if="temp.ali_image!=''" class="aliImg" />
              <img src="../../assets/imgs/personal/upImg.png" alt class="aliImg" v-else />
            </van-uploader>
          </div>
        </van-cell>
      </div>-->
      <!-- <div v-if="type==3">
        <van-field v-model="value" label="微信账号" placeholder="请输入微信账号" input-align="right" />
        <van-cell title="微信收款码">
          <div slot="default">
            <van-uploader :after-read="upWx">
              <img :src="temp.wx_image" alt v-if="temp.wx_image!=''" class="aliImg" />
              <img src="../../assets/imgs/personal/upImg.png" alt class="aliImg" v-else />
            </van-uploader>
          </div>
        </van-cell>
      </div>-->
      <button class="drawBtn" @click="submitWithdraw" :disabled='disabled'>立即提现 </button>

    </div>
    <!-- 选择 -->
    <van-action-sheet v-model="typeShow" :actions="actions" @select="onSelect" close-on-click-action />
  </div>
</template>

<script>
  import { drawConfig, draw, fileUpload } from "@/api/personal";
  export default {
    data() {
      return {
        realMoney: 0,
        typeName: "银行卡",
        active: 0,
        typeShow: false,
        disabled: false,
        actions: [
          { name: "银行卡", id: 1 },
          { name: "支付宝", id: 2 },
          { name: "微信", id: 3 }
        ],
        configTemp: {},
        temp: {
          money: "",
          pay_password: "",
          type: 1
        }
      };
    },
    created() {
      drawConfig().then(res => {
        this.configTemp = res;
        if (!res.id) {
          this.$toast('平台该功能暂未开启!');
          this.disabled = true;
        }
      });
    },
    methods: {
      // 实际金额
      getReal() {
        this.realMoney = this.temp.money - this.temp.money * (this.configTemp.rate / 100);
      },
      upAli(file) {
        let formData = new FormData();
        formData.append("image", file.file);
        fileUpload(formData).then(res => {
          this.temp.ali_image = res.path;
        });
      },
      upWx(file) {
        let formData = new FormData();
        formData.append("image", file.file);
        fileUpload(formData).then(res => {
          this.temp.wx_image = res.path;
        });
      },
      //    切换
      onSelect(item) {
        this.typeName = item.name;
        this.temp.type = item.id;
      },
      // 申请提现
      submitWithdraw() {
        let temp = this.temp;
        // if (this.type == 1) {
        //   if (
        //     !temp.bank_name ||
        //     !temp.bank_number ||
        //     !temp.bank_open ||
        //     !temp.bank_open_name
        //   ) {
        //     this.$toast("请填写完整信息!");
        //     return;
        //   }
        // } else if (this.type == 2) {
        //   if (!temp.ali_number || !temp.ali_image) {
        //     this.$toast("请填写完整信息!");
        //     return;
        //   }
        // } else if (this.type == 3) {
        //   if (!temp.wx_number || !temp.wx_image) {
        //     this.$toast("请填写完整信息!");
        //     return;
        //   }
        // }
        if (!this.temp.money) {
          this.$toast("请填写提现金额!");
          return;
        }
        draw(this.temp).then(res => {
          this.$toast('提现成功!');
          setTimeout(() => {
            this.$router.push({ name: 'mywalletlist' });
          }, 200);
        });
      }
    }
  };
</script>
<style lang='less' scoped>
  .wrap {
    position: relative;
    height: 100vh;

    .withdrawCon {
      width: 355px;
      margin: 10px auto;
      padding-bottom: 15px;

      .van-cell-group {
        border-radius: 14px 14px 0 0;

        .van-cell {
          border-radius: 14px 14px 0 0;
        }
      }

      .drawBtn {
        position: absolute;
        border: 0 none;
        font-size: 16px;
        width: 345px;
        height: 44px;
        line-height: 1;
        color: #fff;
        background:#3B6BFB;
        margin-top: 100px;
        left: 50%;
        transform: translateX(-50%);
        border-radius: 22px;
      }
    }

    .aliCode {
      width: 120px;
      height: 120px;
    }
  }
</style>